var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[(_vm.getCurrentProject)?_c('TableHPReportOverview',{key:_vm.projectId,attrs:{"current-project":_vm.getCurrentProject,"projects-list":_vm.getProjects},on:{"changeProject":function($event){return _vm.getProjectPage($event)}}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }